export enum ViewCode {
  design = 0,
  live = 1,
  costs = 2,
  inventory = 3,
  home = 4,
  admin = 5
}
